import { render, staticRenderFns } from "./NewVehicleGroup.vue?vue&type=template&id=3ece25f6&scoped=true&"
import script from "./NewVehicleGroup.vue?vue&type=script&lang=js&"
export * from "./NewVehicleGroup.vue?vue&type=script&lang=js&"
import style0 from "./NewVehicleGroup.vue?vue&type=style&index=0&id=3ece25f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ece25f6",
  null
  
)

export default component.exports